<template>
   <div>
       <div class="lastFollowResult" v-if="loaded && followInfo.length">
           <div class="followItem" v-for="(item,index) in followInfo" :key="index">
               <span class="label">{{item.fileName}}:</span>
               <span class="value">{{item.fileValue}}</span>
           </div>
           <template v-if="!followInfo || followInfo.length==0">
        <span class="no-data">
            <p>暂无上次随访数据</p>
            <img src="./img/no-result.png" alt="暂无上次随访数据">
        </span>
           </template>
       </div>
   </div>
</template>

<script type="text/ecmascript-6">
    import {mapState, mapMutations, mapGetters} from 'vuex';
    import {
        RestNewFollowupCallCenterServiceGetLastFollowupQuestionnaireHistory,
        RestNewFollowupCallCenterServiceGetAdmitNoAndHistoryFollowupData
    } from "@src/assets/js/api.js";

    export default {
        name: 'lastFollowResult',
        props: {
            patientData: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        data() {
            return {
                loaded: false,
                followInfo: []
            }
        },
        computed: {
            ...mapState(['follupTime']),
            ...mapGetters([
                'userid',
                'patientId',
                'taskValue',
                'username',
                'getTaskCenterId',
            ]),
        },
        components: {},
        methods: {
            ...mapMutations(['setFollowupTime', 'setFollowupTimeString', 'setStringWithFollupTime']),
            onLoad() {
                let vm = this;
                // vm.getLastResult({
                //     pid:vm.patientData.followupPatientId
                // })
                vm.asyncGetFollowResultByAdminNo({
                    admitNo: vm.patientData.admitNo
                })
            },
            async getLastResult(params) {
                let vm = this;
                let info = new RestNewFollowupCallCenterServiceGetLastFollowupQuestionnaireHistory();
                info.p_followupPatientId = params.pid
                info.p_followupTaskId = vm.getTaskCenterId;
                await info.send()
                if (info.result.status == 0) {
                    vm.followInfo = []
                    info.result.retValue.forEach((item) => {
                        vm.followInfo.push({
                            fileName: item['key'],
                            fileValue: item['value']
                        })
                    })
                } else {
                    vm.followInfo = []
                }
                vm.loaded = true

            },
            async asyncGetFollowResultByAdminNo(p) {
                let vm = this;
                let info = new RestNewFollowupCallCenterServiceGetAdmitNoAndHistoryFollowupData()
                info.p_admitNo = p.admitNo
                await info.send()
                if (info.result.status == 0 && info.result.retValue.length > 2) {
                    vm.followInfo = []
                    info.result.retValue = JSON.parse(info.result.retValue)
                    info.result.retValue.forEach((item) => {
                        vm.followInfo.push({
                            fileName: item['key'],
                            fileValue: item['value']
                        })
                    })
                } else {
                    vm.followInfo = []
                }
                vm.loaded = true

            }
        },
        created() {
        },
        mounted() {
            let vm = this;
            vm.onLoad()
        },
    }
</script>

<style scoped lang="scss">
    .lastFollowResult {
        width: 100%;
        max-width: 450px;
        height: 650px;
        overflow: auto;

        .followItem {
            margin-top: 10px;
            margin-bottom: 10px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.08);
            display: flex;
            justify-content: flex-start;

            .label {
                /*width: 25%;*/
                min-width: 100px;
                font-size: 16px;
                font-weight: 600;
                letter-spacing: 1px;
                text-align: left;
                max-width: 50%;
            }

            .value {
                /*width: 75%;*/
                text-align: justify;
                line-height: 23px;
                font-size: 16px;
                letter-spacing: 1px;
                margin-left: 10px;
            }
        }
    }

    .no-data {
        p {
            margin: 40px 0 80px;
            font-size: 16px;
            color: rgba(0, 0, 0, 1);
        }

        display: table-cell;
        height: 60vh;
        vertical-align: middle;
        text-align: center;
        width: 480px;
        height: 100%;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.16), 0px 0px 2px 0px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        padding: 15px 15px 15px 20px;
        box-sizing: border-box;
        margin-top: 20px;
        margin-bottom: 20px;

    }

</style>
